import { useNavigate } from 'react-router-dom'

import { clsx } from 'clsx'

import { HeaderVariant } from 'shared/ui/header/header.tsx'

import { HeaderGoBack } from '../header-go-back'

import s from './styles.module.scss'

interface Props {
  title?: string
  onBack?: () => void
  onClick?: () => void
  variant?: HeaderVariant
  buttonTitle?: string
}

export const HeaderButton = ({
  title,
  onBack,
  onClick,
  buttonTitle,
  variant = 'white',
}: Props) => {
  const navigate = useNavigate()

  const onGoBack = () => {
    if (onBack) return onBack()

    navigate(-1)
  }

  return (
    <HeaderGoBack
      buttonWhite
      title={title}
      variant={variant}
      onGoBack={onGoBack}
      actionRight={
        <p
          className={clsx(s.button)}
          onClick={onClick}
        >
          {buttonTitle}
        </p>
      }
    />
  )
}
